import React from 'react';

export const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 100, height: 34 },
    default: { width: 140, height: 48 },
    large: { width: 200, height: 68 },
  };

  const { width, height } = sizes[size] || sizes.default;

  return (
    <img
      src="/logo.png"
      alt="Tiffin & Bag - Packed with Fun!"
      width={width}
      height={height}
      className={`object-contain ${className}`}
      loading="eager"
    />
  );
};

export const LogoWithText = ({ className = "", showTagline = false }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <Logo size="default" />
    </div>
  );
};
